import React from 'react';
import { cn } from '../../lib/utils';

export interface SurfaceProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export function Surface({ children, className, id, onClick }: SurfaceProps) {
  return (
    <div id={id} onClick={onClick} className={cn(className)}>
      {children}
    </div>
  );
}
